import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import StarryBackground from './components/StarryBackground';
import InstallPrompt from './components/InstallPrompt';
import FloatingLanguageToggle from './components/FloatingLanguageToggle';
import Landing from './pages/Landing';
import Auth from './pages/Auth';
import AuthCallback from './pages/AuthCallback';
import ResetPassword from './pages/ResetPassword';
import Welcome from './pages/Welcome';
import INTake from './pages/INTake';
import Assessment from './pages/Assessment';
import Dashboard from './pages/Dashboard';
import DomainDetail from './pages/DomainDetail';
import CheckIn from './pages/CheckIn';
import Progress from './pages/Progress';
import MissionControl from './pages/MissionControl';
import Settings from './pages/Settings';
import MorningGuidance from './pages/MorningGuidance';
import EveningCheckIn from './pages/EveningCheckIn';
import Coaching from './pages/Coaching';
import WeeklyGoalsCheckIn from './pages/WeeklyGoalsCheckIn';
import INtegrate from './pages/INtegrate';
import TheINN from './pages/TheINN';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FeedbackSurvey from './pages/FeedbackSurvey';
import AdminPanel from './pages/AdminPanel';
import About from './pages/About';
import SharedSunMap from './pages/SharedSunMap';
import Navigator from './pages/Navigator';
import OrbitList from './pages/OrbitList';
import CreateOrbit from './pages/CreateOrbit';
import OrbitDetail from './pages/OrbitDetail';
import JoinOrbit from './pages/JoinOrbit';
import OrbitMissionControl from './pages/OrbitMissionControl';
import MapReveal from './pages/MapReveal';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// Router component that detects OAuth callback
function AppRouter() {
  const location = useLocation();
  
  // Check URL fragment (not query params) for session_id - must be synchronous
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/intake" element={<INTake />} />
      <Route path="/assessment" element={<Assessment />} />
      <Route path="/map-reveal" element={<MapReveal />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/checkin" element={<CheckIn />} />
      <Route path="/progress" element={<MissionControl />} />
      <Route path="/mission-control" element={<MissionControl />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/morning" element={<MorningGuidance />} />
      <Route path="/evening" element={<EveningCheckIn />} />
      <Route path="/coaching" element={<Coaching />} />
      <Route path="/goals-checkin" element={<WeeklyGoalsCheckIn />} />
      <Route path="/integrate" element={<INtegrate />} />
      <Route path="/inn" element={<TheINN />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/feedback" element={<FeedbackSurvey />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/about" element={<About />} />
      <Route path="/shared/:shareId" element={<SharedSunMap />} />
      <Route path="/domain/:domainKey" element={<DomainDetail />} />
      <Route path="/mission-control" element={<MissionControl />} />
      <Route path="/navigator" element={<Navigator />} />
      <Route path="/orbit" element={<OrbitList />} />
      <Route path="/orbit/create" element={<CreateOrbit />} />
      <Route path="/orbit/join/:inviteCode" element={<JoinOrbit />} />
      <Route path="/orbit/:orbitId" element={<OrbitDetail />} />
      <Route path="/orbit/:orbitId/mission-control/:paramKey" element={<OrbitMissionControl />} />
    </Routes>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <StarryBackground />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: 'rgba(10, 10, 15, 0.9)',
              color: '#F8F5F2',
              border: '1px solid rgba(212, 175, 55, 0.3)',
            },
          }}
        />
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
        <InstallPrompt />
        <FloatingLanguageToggle />
      </div>
    </LanguageProvider>
  );
}

export default App;
